<template>
  <svg
    width="24px"
    height="24px"
    viewBox="0 0 24 24"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
  >
    <title>Flag / Region / Malaysia</title>
    <defs>
      <circle id="path-1" cx="12" cy="12" r="12"></circle>
    </defs>
    <g
      id="Flag-/-Region-/-Malaysia"
      stroke="none"
      stroke-width="1"
      fill="none"
      fill-rule="evenodd"
    >
      <mask id="mask-2" fill="white">
        <use xlink:href="#path-1"></use>
      </mask>
      <g id="Mask" fill-rule="nonzero"></g>
      <g id="my" mask="url(#mask-2)">
        <polygon
          id="Path"
          fill="#CC0001"
          points="0 0 24 0 24 24 0 24"
        ></polygon>
        <polygon
          id="a"
          fill="#FFFFFF"
          points="0 22.2890625 24 22.2890625 24 24 0 24"
        ></polygon>
        <g
          id="a-link"
          transform="translate(0.000000, 18.839063)"
          fill="#FFFFFF"
        >
          <polygon
            id="a"
            points="0 0.0234375 24 0.0234375 24 1.734375 0 1.734375"
          ></polygon>
        </g>
        <g
          id="a-link"
          transform="translate(0.000000, 15.407813)"
          fill="#FFFFFF"
        >
          <polygon
            id="a"
            points="0 0.0234375 24 0.0234375 24 1.734375 0 1.734375"
          ></polygon>
        </g>
        <g
          id="a-link"
          transform="translate(0.000000, 11.981250)"
          fill="#FFFFFF"
        >
          <polygon
            id="a"
            points="0 0.0234375 24 0.0234375 24 1.734375 0 1.734375"
          ></polygon>
        </g>
        <g id="a-link" transform="translate(0.000000, 8.550000)" fill="#FFFFFF">
          <polygon
            id="a"
            points="0 0.0234375 24 0.0234375 24 1.734375 0 1.734375"
          ></polygon>
        </g>
        <g id="a-link" transform="translate(0.000000, 5.123438)" fill="#FFFFFF">
          <polygon
            id="a"
            points="0 0.0234375 24 0.0234375 24 1.734375 0 1.734375"
          ></polygon>
        </g>
        <g id="a-link" transform="translate(0.000000, 1.692188)" fill="#FFFFFF">
          <polygon
            id="a"
            points="0 0.0234375 24 0.0234375 24 1.734375 0 1.734375"
          ></polygon>
        </g>
        <polygon
          id="Path"
          fill="#010066"
          points="0 0 15 0 15 13.715625 0 13.715625"
        ></polygon>
        <g id="Group" transform="translate(1.406250, 2.390625)" fill="#FFCC00">
          <path
            d="M4.396875,0.0421773995 C3.23988518,0.0396986781 2.12936205,0.497246281 1.30992704,1.31404363 C0.490492024,2.13084098 0.0293664011,3.23988316 0.0281203662,4.396875 C0.0257979821,5.99679878 0.900066212,7.46944278 2.30579103,8.23344492 C3.71151584,8.99744706 5.42279619,8.93003163 6.7640625,8.0578125 C6.35683325,8.19793864 5.92910067,8.2692274 5.4984375,8.26875 C4.47279469,8.27123942 3.48817095,7.8661903 2.7611738,7.14270947 C2.03417665,6.41922863 1.62435839,5.43658033 1.621875,4.4109375 C1.621875,2.278125 3.35625,0.5484375 5.49375,0.5484375 C5.95253167,0.546240982 6.40805244,0.625600001 6.8390625,0.7828125 C6.11922863,0.301293393 5.27228594,0.0450891495 4.40625,0.046875 L4.396875,0.0421773995 Z"
            id="Path"
          ></path>
          <polygon
            id="Path"
            points="11.64375 6.665625 9.796875 5.7046875 10.340625 7.66875 9.1125 6.028125 8.728125 8.025 8.353125 6.0234375 7.1109375 7.6640625 7.6640625 5.7 5.821875 6.65625 7.190625 5.11875 5.1046875 5.1984375 7.021875 4.396875 5.1046875 3.5859375 7.190625 3.6703125 5.83125 2.128125 7.66875 3.0890625 7.125 1.125 8.353125 2.765625 8.7375 0.76875 9.1125 2.7703125 10.359375 1.125 9.80625 3.09375 11.6484375 2.1375 10.2796875 3.675 12.365625 3.5953125 10.4484375 4.4015625 12.365625 5.2078125 10.2796875 5.1234375"
          ></polygon>
        </g>
      </g>
    </g>
  </svg>
</template>

<script>
export default {};
</script>

<style>
</style>